// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"aJ-z","smallCardRow":"bJ-z","largeCardRow":"cJ-z","productSearchRow":"dJ-z","curatedRow":"eJ-z"};